if (!customElements.get('size-chart-button')) {
  class SizeChartButton extends HTMLElement {
    constructor() {
      super();
      this.modal = null;
      this.handleButtonClick = this.handleButtonClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.isLoading = false;
    }

    async connectedCallback() {
      await this.getImageIfBundle();
      this.setAttribute('tabindex', '0');
      this.setAttribute('role', 'button');
      this.setAttribute('aria-haspopup', 'dialog');
      this.setAttribute('aria-label', 'Deschide tabel marimi');
      this.addEventListener('click', this.handleButtonClick);
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleButtonClick();
        }
      });
      // Preload image if already present
      if (this.dataset.imageUrl) {
        const preloadImg = new window.Image();
        preloadImg.src = this.dataset.imageUrl;
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleButtonClick);
      if (this.modal) {
        this.modal.remove();
      }
    }

    async getImageIfBundle() {
      const imageExists = this.dataset.imageUrl;
      if (imageExists) {
        return;
      }

      const optionName = this.dataset.optionName?.split('(')[0].trim();
      const productHandle = this.dataset.productHandle;
      const shopId = this.dataset.shopId;

      if (!optionName || !shopId || this.dataset.optionName === 'Mărime') {
        return;
      }

      try {
        const response = await fetch(
          `https://dispotrading-hub.gadget.app/size-chart?shopId=${encodeURIComponent(shopId)}&title=${encodeURIComponent(optionName)}`
        );

        const data = await response.json();

        if (data.success && data.image && data.image.url) {
          this.dataset.imageUrl = data.image.url;
          this.classList.remove('hidden');
          // Preload image
          const preloadImg = new window.Image();
          preloadImg.src = data.image.url;
        }
      } catch (err) {
        console.log(err);
      }
    }

    handleButtonClick() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.showModal();
    }

    handleCloseClick() {
      if (this.modal) {
        this.modal.classList.remove('active');
        document.body.style.overflowY = 'scroll';
        this.modal.remove();
        this.modal = null;
        this.isLoading = false;
        this.button && this.button.focus();
      }
    }

    handleKeyDown(e) {
      if (e.key === 'Escape') {
        this.handleCloseClick();
      }
      // Trap focus inside modal
      if (e.key === 'Tab' && this.modal) {
        const focusable = this.modal.querySelectorAll('button, [tabindex]:not([tabindex="-1"])');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    }

    showModal() {
      const imageUrl = this.dataset.imageUrl;
      if (!imageUrl) return;
      this.modal = document.createElement('div');
      this.modal.className = 'modal-container active';
      this.modal.setAttribute('role', 'dialog');
      this.modal.setAttribute('aria-modal', 'true');
      this.modal.innerHTML = `
        <div class="modal" tabindex="-1">
          <div class="page-width">
            <div class="modal-container__inner">
              <button type="button" class="modal-close-button" aria-label="Inchide tabel marimi">&times;</button>
              <div class="modal-image-container">
                <img src="${imageUrl}" width="100%" height="100%" alt="Tabel marimi" loading="lazy">
              </div>
            </div>
          </div>
        </div>
      `;
      document.body.appendChild(this.modal);
      document.body.style.overflowY = 'hidden';
      const closeBtn = this.modal.querySelector('.modal-close-button');
      closeBtn.addEventListener('click', this.handleCloseClick);
      this.modal.addEventListener('keydown', this.handleKeyDown);
      // Close modal when clicking outside modal content
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) {
          this.handleCloseClick();
        }
      });
      // Focus modal for accessibility
      setTimeout(() => {
        closeBtn.focus();
      }, 10);
    }
  }
  customElements.define('size-chart-button', SizeChartButton);
} 